<script>
    export default {
        data() {
            return {
                index: 'cookieConsent'
            }
        },
        computed: {
            isCookie() {
                return window.Cookies.get(this.index);
            }
        },
        methods: {
            set() {
                if (this.isCookie) {
                    window.Cookies.remove(this.index);
                } else {
                    window.Cookies.set(this.index, 1);
                }
                window.location.reload(true);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Cookie/Cookie.vue